import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewsReportComponent } from './views-report/views-report.component';
import { NgxPaginationModule } from 'ngx-pagination';

@NgModule({
  declarations: [
    ViewsReportComponent
  ],
  imports: [
    CommonModule,
    NgxPaginationModule
  ]
})
export class ReportsModule { }
